const messages = {
  title: "Bonusni množilnik",
  bandBonusTitle: "Bonus na pnevmatiko z množilnikom",
  amountLabel: "Min. število pnevmatik (*)",
  label: "Bonusni množilnik",
  desc: "Število pnevmatik Bridgestone in Firestone. Za pnevmatike Firestone ni bonusa v evrih.",
  goals: {
    loyal: "Zvest",
    bronze: "Bron",
    silver: "Srebro",
    gold: "Zlato",
    platinum: "Platina",
  },
  andMore: "in več",
  chooseTarget: "Izberi",
  selectTarget: "Izberite svoj letni cilj za {year}:",
  multiplication: "Bonus se množi z <b>{factor}</b>",
  minTyres: "<b>Minimum:</b> {tyre} pnevmatik",
};

export default {
  messages,
};
